// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__PH-yg","itemTitle":"ClientEmergencyInfo_itemTitle__1CwuX","itemText":"ClientEmergencyInfo_itemText__38-iR"};